// import * as MD from '@material-ui/core';
import * as React from 'react';
import { Layout } from '../Components/Layout';
import { setDrawerContent, setPageContent } from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../Store';
// IApplicationState,
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ILayoutState } from '../Store/Layout/Types';
import { StatisticsRepartitionContent } from '../Components/Statistics/StatisticsRepartitionContent';
import { StatisticsEvolutionContent } from '../Components/Statistics/StatisticsEvolutionContent';
import { StatsRepartitionDrawer } from '../Components/Sidebar/StatsRepartitionDrawer';
import { StatsEvolutionDrawer } from '../Components/Sidebar/StatsEvolutionDrawer';
import { TypedStorage } from '../Utils/TypedStorage';

interface IPropsFromState {
    layout: ILayoutState;
}

interface IPropsFromDispatch {
    setDrawerContent: typeof setDrawerContent;
    setPageContent: typeof setPageContent;
}

type AllProps =
    IPropsFromDispatch &
    IPropsFromState &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

export class StatisticsPage extends React.Component<AllProps> {

    public componentDidMount() {
        if (TypedStorage.get("statsPage", "") === "statsRepartition") {
            this.props.setPageContent(<Route component={StatisticsRepartitionContent} />);
            this.props.setDrawerContent(<Route component={StatsRepartitionDrawer} />)
            this.props.history.push('/statistics')
        }
        if (TypedStorage.get("statsPage", "") === "statsEvolution") {
            this.props.setPageContent(<Route component={StatisticsEvolutionContent} />);
            this.props.setDrawerContent(<Route component={StatsEvolutionDrawer} />)
            this.props.history.push('/statistics')
        }
    }

    public render(): React.ReactNode {

        return (
            <Route component={Layout} />
        );
    }
}

const mapStateToProps = ({ layout }: IApplicationState) => ({
    layout,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
    setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
});

export const Statistics = connect(mapStateToProps, mapDispatchToProps)(StatisticsPage);
